import { render } from "./editDealer.vue?vue&type=template&id=e48fc8c4"
import script from "./editDealer.vue?vue&type=script&lang=js"
export * from "./editDealer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__